import { z } from 'zod'
import { roleSchema } from '../schemas/roles.schema'

export enum Permission {
  ROLES = 'roles',
  COMPANIES_READ = 'companies:read',
  COMPANIES_UPDATE = 'companies:update',
  USERS_CREATE = 'users:create',
  USERS_UPDATE = 'users:update',
  USERS_DELETE = 'users:delete',
  USERS_ACCEPT = 'users:accept',
  WORKSPACES_READ = 'workspaces:read',
  WORKSPACES_CREATE = 'workspaces:create',
  WORKSPACES_DELETE = 'workspaces:delete',
  WORKSPACES_READ_ALL = 'workspaces:read_all',
  WORKSPACES_UPDATE = 'workspaces:update',
  MATERIALS_READ = 'materials:read',
  MATERIALS_MANAGE = 'materials:manage',
  CONSTRUCTION_LOG_READ = 'construction_log:read',
  CONSTRUCTION_LOG_MANAGE = 'construction_log:manage',
  INSPECTIONS_READ = 'inspections:read'
}

export enum DefaultRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member'
}

export type Role = z.infer<typeof roleSchema>
